import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';

import Field from '#client/components/Field';

import useCityField from './useCityField';

function CityField({ helperText, namePrefix, validation, ...delegated }) {
  const { error, field } = useCityField({ namePrefix, validation });

  return (
    <Field
      {...field}
      error={error}
      helperText={helperText || error?.message}
      inputProps={{
        autoComplete: 'address-level2',
        'data-testid': 'city'
      }}
      label={<FormattedMessage id="shopping.component.addressFieldset.cityField.label" />}
      {...delegated}
    />
  );
}

CityField.propTypes = {
  helperText: PropTypes.string,
  namePrefix: PropTypes.string,
  validation: PropTypes.object
};

export default CityField;
